<dashboardnav>
  <cradua-access-right [accessrights]="accessrights$ | async" (accessright)="onSubmitAccessRight($event)"
    (deleteAccessRightEvent)="onDeleteAccessRight($event)" *ngIf="(isLoadingAccessRight$ | async ) === false">
  </cradua-access-right>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingAccessRight$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
